import { error } from "ajv/dist/vocabularies/applicator/dependencies.js";
import apiClient, { Image_Url } from "./ApiClient.js";

// const getServerUrl = () => {
//   return "http://localhost:3001";
// };


const getServerUrl = () => {
  return "http://18.217.234.106:3001/";
};

export const SERVER_URL = getServerUrl();

export const S3_URL =
  process.env.REACT_APP_IMAGE_BASE_URL ||
  "https://areatrek-live-bucket.s3.us-east-2.amazonaws.com";

export const IMAGE_BASE_URL =
  process.env.REACT_APP_IMAGE_BASE_URL ||
  "https://areatrek-live-bucket.s3.us-east-2.amazonaws.com";

export const ROOM_TYPE_FOLDER = "room-types/";

export { Image_Url };

//Area Trek admin api functions

export const adminlogin = async (data) => {
  try {
    const response = await apiClient.post("admin/login", data);
    console.log("admin login response:", response.data);
    return response.data;
    console.log("admin login response:", response.data);
  } catch (error) {
    console.error("Error admin login error:", error);
    throw error;

  }

};

export const adminforgotpassword = async (data) => {
  try {
    const response = await apiClient.post("/admin/forget-password", data);
    return response.data;
  } catch (error) {
    console.error("Error admin forgotpassword  error:", error);
    throw error;

  }
};


export const verifyOtp = async (email, otp) => {
  try {
    const response = await apiClient.post("/admin/verify-otp", { email, otp });
    return response.data;
  } catch (error) {
    console.error("Error admin verify otp error:", error);
    throw error;
  }
};

export const resetPassword = async (
  email,
  newPassword,
  confirmPassword
) => {
  try {
    const response = await apiClient.post("/admin/set-new-password", {
      email,
      newPassword,
      confirmNewPassword: confirmPassword,
    });

    return response.data;
  } catch (error) {
    console.error("Reset password API error:", error);

    // Important: don't return a fake success response
    throw error;
  }
};





export const getalluserdetails = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  type = ""
) => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-users-list",
      {
        params: {
          page,
          limit,
          search,
          status,
          type,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get all users API error:", error);

    // Re-throw so the component can handle
    // 401, 403, 404, 500, etc.
    throw error;
  }
};



export const getuserdetailsbyid = async (uuid) => {
  try {
    const response = await apiClient.get(`/admin/private/users/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching user details by ID:", error);
    throw error;
  }
};


export const adduserdetails = async (data) => {
  try {
    const response = await apiClient.post("/admin/private/users", data);

    return response.data;
  } catch (error) {
    console.error("Error adding user details:", error);
    throw error;
  }
};

export const updateuserdetails = async (data) => {
  try {
    const response = await apiClient.put(
      `/admin/private/update-users`,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error updating user details:", error);
    throw error;
  }
};


export const deleteuserdetails = async (uuid) => {
  try {
    const response = await apiClient.delete(`/admin/private/delete-users/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting user details:", error);
    throw error;
  }
};

export const sendUserWarning = async (data) => {
  try {
    const response = await apiClient.post("/admin/private/send-user-warning", data);
    return response.data;
  } catch (error) {
    console.error("Error sending user warning:", error);
    throw error;
  }
};

export const sendGuideWarning = async (data) => {
  try {
    const response = await apiClient.post("/admin/private/send-guide-warning", data);
    return response.data;
  } catch (error) {
    console.error("Error sending guide warning:", error);
    throw error;
  }
};


export const getadmindetaildbyid = async (uuid) => {
  try {
    const response = await apiClient.get(
      `/admin/private/get-admin-profile/${uuid}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching admin details:", error);
    throw error;
  }
};



export const updateAdminProfile = async (uuid, formData) => {
  try {
    const response = await apiClient.put(
      `/admin/private/update-admin-profile/${uuid}`,
      formData
    );

    return response.data;
  } catch (error) {
    console.error("Error updating admin profile:", error);
    console.error("Response:", error?.response?.data);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : get privacy policy 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */
export const getPrivacyPolicy = async () => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-privacy-policy"
    );

    return response.data;
  } catch (error) {
    console.error("Error getPrivacyPolicy:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : save privacy policy 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */

export const savePrivacyPolicy = async (data) => {
  try {
    const response = await apiClient.post(
      "/admin/private/save-privacy-policy",
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error savePrivacyPolicy:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : get term&condition 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */


export const getTermsAndConditions = async () => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-term-condition"
    );

    return response.data;
  } catch (error) {
    console.error("Error getTermsAndConditions:", error);
    throw error;
  }
};




/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : save term&condition 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */


export const saveTermsAndConditions = async (data) => {
  try {
    const response = await apiClient.post(
      "/admin/private/save-Term-Condition",
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error saveTermsAndConditions:", error);
    throw error;
  }
};




/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : get contact us detail 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */

export const getContact = async () => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-contact-us"
    );

    return response.data;
  } catch (error) {
    console.error("Error getContact:", error);
    throw error;
  }
};




/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : save contact us detail 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */


export const saveContact = async (data) => {
  try {
    const response = await apiClient.post(
      "/admin/private/save-contact-us",
      data
    );

    return response.data;
  } catch (error) {
    console.error("Error saveContact:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : get-guide-verification 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */


export const getGuideVerification = async ({
  page = 1,
  limit = 10,
  search = "",
  status = "",
} = {}) => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-guide-verification",
      {
        params: {
          page,
          limit,
          search,
          status,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error getGuideVerification:", error);
    throw error;
  }
};



/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : guide-verification-approve 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */




export const approveGuideVerification = async (verificationId) => {
  try {
    const response = await apiClient.put(
      `/admin/private/guide-verification/${verificationId}/approve`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error approveGuideVerification:",
      error
    );
    throw error;
  }
};



/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : guide-verification-reject
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */


export const rejectGuideVerification = async (
  verificationId,
  rejectionReason
) => {
  try {
    const response = await apiClient.put(
      `/admin/private/guide-verification/${verificationId}/reject`,
      {
        rejectionReason,
      }
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error rejectGuideVerification:",
      error
    );
    throw error;
  }
};




/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : getguideverificationbyid
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */


export const getGuideVerificationById = async (verificationId) => {
  try {
    const response = await apiClient.get(
      `/admin/private/guide-verification/${verificationId}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Error getGuideVerificationById:",
      error
    );
    throw error;
  }
};



/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : get dashboard count
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */




export const getDashboardStats = async () => {
  try {
    const response = await apiClient.get("/admin/private/get-dashboard-state");

    return response.data;
  } catch (error) {
    console.error("Get dashboard stats error:", error);
    throw error;
  }
};





/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : addCategory 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */

export const addCategory = async (data) => {
  try {
    const response = await apiClient.post(
      "/admin/private/add-categories",
      data
    );

    return response.data;
  } catch (error) {
    console.error("Add category error:", error);
    throw error;
  }
};



/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description :get addCategory 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */

export const getCategories = async ({
  search = "",
  page = 1,
  limit = 10,
} = {}) => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-categories",
      {
        params: {
          search,
          page,
          limit,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get categories error:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : update Category 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */

export const updateCategory = async (uuid, data) => {
  try {
    const response = await apiClient.put(
      `/admin/private/update-categories/${uuid}`,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Update category error:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : delete Category 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */

export const deleteCategory = async (uuid) => {
  try {
    const response = await apiClient.delete(
      `/admin/private/delete-categories/${uuid}`
    );

    return response.data;
  } catch (error) {
    console.error("Delete category error:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : toggele Category status 
 *
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */

export const toggleCategoryStatus = async (uuid) => {
  try {
    const response = await apiClient.put(
      `/admin/private/toggle-Category-Status/${uuid}`
    );

    return response.data;
  } catch (error) {
    console.error("Toggle category status error:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : getDashboardStatsmonthly
 * 
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */




export const getDashboardStatsmonthly = async () => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-dashboard-state-monthly"
    );

    return response.data;
  } catch (error) {
    console.error("Get dashboard stats error:", error);
    throw error;
  }
};



/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : getMemberships detail
 * 
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */





export const getMemberships = async (params) => {
  try {
    const response = await apiClient.get("/admin/private/getMemberships", {
      params,
    });

    return response.data;
  } catch (error) {
    console.error("Error fetching memberships:", error);
    throw error;
  }
};





/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : getMemberships detail by uuid
 * 
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */

export const getMembershipById = async (uuid) => {
  try {
    const response = await apiClient.get(
      `/admin/private/membership/${uuid}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching membership details:", error);
    throw error;
  }
};



/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : getTourPackageById
 * 
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */



export const getTourPackageById = async (uuid) => {
  try {
    const response = await apiClient.get(
      `/admin/private/get-tour-package-detailbyid/${uuid}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching tour package details:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : getTourPackagesDetail
 * 
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */





export const getTourPackagesDetail = async () => {
  try {
    const response = await apiClient.get(
      `/admin/private/get-tourpackages-detail`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching tour packages details:", error);
    throw error;
  }
};


/**
 * ============================================================
 * Zero IT Solutions
 * ============================================================
 * Project     : Area Trek
 * File        : ApiServices.js
 * Description : togglePackageStatus
 * 
 * Author      : Zero IT Solutions
 * Created     : 2026-08-17
 * ============================================================
 */


export const togglePackageStatus = async (uuid) => {
  try {
    const response = await apiClient.put(
      `/admin/private/toggle-Package-Status/${uuid}`
    );

    return response.data;
  } catch (error) {
    console.error(
      "Toggle package status API error:",
      error.response?.data || error.message
    );

    throw error;
  }
};






/**
 * ------------------------------------------------------------
 * Add FAQ
 * ------------------------------------------------------------
 * @route   POST /admin/private/add-faq
 * @access  Private - Admin
 *
 * @body
 * {
 *   question: "What is Area Trek?",
 *   answer: "Area Trek is a travel platform."
 * }
 * ------------------------------------------------------------
 */
export const addFaq = async (data) => {
  try {
    const response = await apiClient.post(
      "/admin/private/add-faq",
      data
    );

    return response.data;
  } catch (error) {
    console.error("Add FAQ API error:", error);

    throw error.response?.data || {
      success: false,
      message: "Failed to add FAQ",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Get FAQs
 * ------------------------------------------------------------
 * @route   GET /admin/private/get-faq
 * @access  Private - Admin
 *
 * @query
 * page
 * limit
 * ------------------------------------------------------------
 */
export const getFaqs = async (page = 1, limit = 10, search = "") => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-faq",
      {
        params: {
          page,
          limit,
          search,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get FAQ API error:", error);

    throw error.response?.data || {
      success: false,
      message: "Failed to fetch FAQs",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Update FAQ
 * ------------------------------------------------------------
 * @route   PUT /admin/private/update-faq/:uuid
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const updateFaq = async (uuid, data) => {
  try {
    const response = await apiClient.put(
      `/admin/private/update-faq/${uuid}`,
      data
    );

    return response.data;
  } catch (error) {
    console.error("Update FAQ API error:", error);

    throw error.response?.data || {
      success: false,
      message: "Failed to update FAQ",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Delete FAQ
 * ------------------------------------------------------------
 * @route   DELETE /admin/private/delete-faq/:uuid
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const deleteFaq = async (uuid) => {
  try {
    const response = await apiClient.delete(
      `/admin/private/delete-faq/${uuid}`
    );

    return response.data;
  } catch (error) {
    console.error("Delete FAQ API error:", error);

    throw error.response?.data || {
      success: false,
      message: "Failed to delete FAQ",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Toggle FAQ Status
 * ------------------------------------------------------------
 * @route   PUT /admin/private/toggle-faq-status/:uuid
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const toggleFaqStatus = async (uuid) => {
  try {
    const response = await apiClient.put(
      `/admin/private/toggle-faq-status/${uuid}`
    );

    return response.data;
  } catch (error) {
    console.error("Toggle FAQ status API error:", error);

    throw error.response?.data || {
      success: false,
      message: "Failed to toggle FAQ status",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Get All Bookings
 * ------------------------------------------------------------
 * @route   GET /admin/private/get-all-bookings
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const getAllBookings = async (params = {}) => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-all-bookings",
      { params }
    );
    return response.data;
  } catch (error) {
    console.error("Get all bookings API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch bookings",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Get Booking Details By UUID
 * ------------------------------------------------------------
 * @route   GET /admin/private/get-booking-details/:uuid
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const getBookingDetailsById = async (uuid) => {
  try {
    const response = await apiClient.get(
      `/admin/private/get-booking-details/${uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Get booking details API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch booking details",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Update Booking Status
 * ------------------------------------------------------------
 * @route   PUT /admin/private/update-booking-status/:uuid
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const updateBookingStatus = async (uuid, data) => {
  try {
    const response = await apiClient.put(
      `/admin/private/update-booking-status/${uuid}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Update booking status API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to update booking status",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Get All Ratings & Reviews
 * ------------------------------------------------------------
 * @route   GET /admin/private/get-all-ratings-reviews
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const getAllRatingsAndReviews = async ({
  page = 1,
  limit = 10,
  search = "",
  rating = "",
  isActive = "",
  reviewType = "",
} = {}) => {
  try {
    const response = await apiClient.get(
      "/admin/private/get-all-ratings-reviews",
      {
        params: {
          page,
          limit,
          search,
          rating: rating === "all" ? "" : rating,
          isActive: isActive === "all" ? "" : isActive,
          reviewType: reviewType === "all" ? "" : reviewType,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get all ratings & reviews API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch ratings and reviews",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Get Rating Review Details By UUID
 * ------------------------------------------------------------
 * @route   GET /admin/private/get-rating-review/:uuid
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const getRatingReviewById = async (uuid) => {
  try {
    const response = await apiClient.get(
      `/admin/private/get-rating-review/${uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Get rating review by ID API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch rating review details",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Toggle Rating Status
 * ------------------------------------------------------------
 * @route   PUT /admin/private/toggle-rating-status/:uuid
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const toggleRatingStatus = async (uuid) => {
  try {
    const response = await apiClient.put(
      `/admin/private/toggle-rating-status/${uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Toggle rating status API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to toggle rating status",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Delete Rating Review
 * ------------------------------------------------------------
 * @route   DELETE /admin/private/delete-rating/:uuid
 * @access  Private - Admin
 * ------------------------------------------------------------
 */
export const deleteRatingReview = async (uuid) => {
  try {
    const response = await apiClient.delete(
      `/admin/private/delete-rating/${uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Delete rating review API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to delete rating review",
    };
  }
};

/**
 * ------------------------------------------------------------
 * Role & Permission Management APIs
 * ------------------------------------------------------------
 */
export const addRole = async (data) => {
  try {
    const response = await apiClient.post("/admin/private/add-role", data);
    return response.data;
  } catch (error) {
    console.error("Add role API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to add role",
    };
  }
};

export const getAllRoles = async (
  page = 1,
  limit = 10,
  search = "",
  status = "",
  adminUuid = ""
) => {
  try {
    const response = await apiClient.get("/admin/private/get-roles", {
      params: {
        page,
        limit,
        search,
        status: status === "all" ? "" : status,
        adminUuid,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get all roles API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch roles",
    };
  }
};

export const getRoleById = async (uuid) => {
  try {
    const response = await apiClient.get(`/admin/private/get-role/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Get role by ID API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch role details",
    };
  }
};

export const updateRole = async (uuid, data) => {
  try {
    const response = await apiClient.put(
      `/admin/private/update-role/${uuid}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Update role API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to update role",
    };
  }
};

export const deleteRole = async (uuid) => {
  try {
    const response = await apiClient.delete(
      `/admin/private/delete-role/${uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Delete role API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to delete role",
    };
  }
};

export const toggleRoleStatus = async (uuid) => {
  try {
    const response = await apiClient.put(
      `/admin/private/toggle-role-status/${uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Toggle role status API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to toggle role status",
    };
  }
};

export const getAllPermissions = async () => {
  try {
    const response = await apiClient.get("/admin/private/get-permissions");
    return response.data;
  } catch (error) {
    console.error("Get permissions API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch permissions",
    };
  }
};

export const syncPermissions = async () => {
  try {
    const response = await apiClient.post("/admin/private/sync-permissions");
    return response.data;
  } catch (error) {
    console.error("Sync permissions API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to sync permissions",
    };
  }
};

/* =====================================================
   ADMIN USERS MANAGEMENT API SERVICES
===================================================== */
export const getAdminUsers = async (
  page = 1,
  limit = 10,
  search = "",
  roleUuid = ""
) => {
  try {
    const response = await apiClient.get("/admin/private/get-admin-users", {
      params: { page, limit, search, roleUuid },
    });
    return response.data;
  } catch (error) {
    console.error("Get admin users API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch admin users",
    };
  }
};

export const addAdminUser = async (data) => {
  try {
    const response = await apiClient.post("/admin/private/add-admin-user", data);
    return response.data;
  } catch (error) {
    console.error("Add admin user API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to create admin user",
    };
  }
};

export const updateAdminUser = async (uuid, data) => {
  try {
    const response = await apiClient.put(
      `/admin/private/update-admin-user/${uuid}`,
      data
    );
    return response.data;
  } catch (error) {
    console.error("Update admin user API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to update admin user",
    };
  }
};

export const deleteAdminUser = async (uuid) => {
  try {
    const response = await apiClient.delete(
      `/admin/private/delete-admin-user/${uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Delete admin user API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to delete admin user",
    };
  }
};

export const toggleAdminUserStatus = async (uuid) => {
  try {
    const response = await apiClient.put(
      `/admin/private/toggle-admin-user-status/${uuid}`
    );
    return response.data;
  } catch (error) {
    console.error("Toggle admin user status API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to toggle admin user status",
    };
  }
};

/**
 * ============================================================
 * Report Management APIs (Admin)
 * ============================================================
 */
export const getAllReports = async ({ page = 1, limit = 10, search = "" } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    if (search) params.append("search", search);

    const response = await apiClient.get(`/admin/private/get-all-reports?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Get all reports API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch reports",
    };
  }
};

export const getReportByUuid = async (uuid) => {
  try {
    const response = await apiClient.get(`/admin/private/get-report/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Get report by UUID API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch report details",
    };
  }
};
export const getReportById = getReportByUuid; // alias

export const replyReport = async (uuid, data) => {
  try {
    const response = await apiClient.post(`/admin/private/reply-report/${uuid}`, data);
    return response.data;
  } catch (error) {
    console.error("Reply report API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to send email reply",
    };
  }
};

/**
 * ============================================================
 * Help & Support Live Chat APIs (Admin)
 * ============================================================
 */
export const getSupportConversations = async ({ page = 1, limit = 50, search = "", status = "all" } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit, status });
    if (search) params.append("search", search);

    const response = await apiClient.get(`/admin/private/support/conversations?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Get support conversations API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch support conversations",
    };
  }
};

export const getSupportMessages = async (conversationUuid, { page = 1, limit = 50 } = {}) => {
  try {
    const params = new URLSearchParams({ page, limit });
    const response = await apiClient.get(`/admin/private/support/messages/${conversationUuid}?${params.toString()}`);
    return response.data;
  } catch (error) {
    console.error("Get support messages API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch conversation messages",
    };
  }
};

export const toggleSupportStatus = async (conversationUuid) => {
  try {
    const response = await apiClient.post(`/admin/private/support/toggle-status/${conversationUuid}`);
    return response.data;
  } catch (error) {
    console.error("Toggle support status API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to update conversation status",
    };
  }
};

export const sendSupportMessage = async (conversationUuid, { message, messageType = "text" } = {}) => {
  try {
    const response = await apiClient.post(`/admin/private/support/messages/${conversationUuid}`, {
      message,
      messageType,
    });
    return response.data;
  } catch (error) {
    console.error("Send support message API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to send support message",
    };
  }
};

// ============================================
// ADMIN NOTIFICATIONS APIs
// ============================================

export const getAdminNotifications = async (limit = 30) => {
  try {
    const response = await apiClient.get(`/admin/private/notifications?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error("Get admin notifications API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to fetch notifications",
    };
  }
};

export const markAdminNotificationRead = async (uuid) => {
  try {
    const response = await apiClient.put(`/admin/private/notifications/${uuid}/read`);
    return response.data;
  } catch (error) {
    console.error("Mark notification read API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to mark notification as read",
    };
  }
};

export const markAllAdminNotificationsRead = async () => {
  try {
    const response = await apiClient.put(`/admin/private/notifications/read-all`);
    return response.data;
  } catch (error) {
    console.error("Mark all notifications read API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to mark all as read",
    };
  }
};

export const clearAllAdminNotifications = async () => {
  try {
    const response = await apiClient.delete(`/admin/private/notifications/clear-all`);
    return response.data;
  } catch (error) {
    console.error("Clear all notifications API error:", error);
    throw error.response?.data || {
      success: false,
      message: "Failed to clear notifications",
    };
  }
};

/**
 * ============================================================
 * Zero IT Solutions - Popular Destination Management APIs
 * ============================================================
 */

export const getDestinations = async ({
  search = "",
  country = "",
  state = "",
  city = "",
  status = "all",
  isPopular = "all",
  page = 1,
  limit = 10,
  sortBy = "displayOrder",
  sortOrder = "asc",
} = {}) => {
  try {
    const response = await apiClient.get("/admin/private/destinations/get", {
      params: {
        search,
        country,
        state,
        city,
        status,
        isPopular,
        page,
        limit,
        sortBy,
        sortOrder,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Get destinations API error:", error);
    throw error.response?.data || error;
  }
};

export const getDestinationByUuid = async (uuid) => {
  try {
    const response = await apiClient.get(`/admin/private/destinations/get/${uuid}`);
    return response.data;
  } catch (error) {
    console.error("Get destination by uuid API error:", error);
    throw error.response?.data || error;
  }
};

export const addDestination = async (formDataOrData) => {
  try {
    const response = await apiClient.post("/admin/private/destinations/add", formDataOrData);
    return response.data;
  } catch (error) {
    console.error("Add destination API error:", error);
    throw error.response?.data || error;
  }
};

export const updateDestination = async (uuid, formDataOrData) => {
  try {
    const response = await apiClient.put(
      `/admin/private/destinations/update/${uuid}`,
      formDataOrData
    );
    return response.data;
  } catch (error) {
    console.error("Update destination API error:", error);
    throw error.response?.data || error;
  }
};

export const toggleDestinationStatus = async (uuid, payload = {}) => {
  try {
    const response = await apiClient.patch(
      `/admin/private/destinations/status/${uuid}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Toggle destination status API error:", error);
    throw error.response?.data || error;
  }
};

export const toggleDestinationPopular = async (uuid, payload = {}) => {
  try {
    const response = await apiClient.patch(
      `/admin/private/destinations/popular/${uuid}`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Toggle destination popular API error:", error);
    throw error.response?.data || error;
  }
};

export const deleteDestination = async (uuid, permanent = false) => {
  try {
    const response = await apiClient.delete(
      `/admin/private/destinations/delete/${uuid}`,
      {
        params: { permanent },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Delete destination API error:", error);
    throw error.response?.data || error;
  }
};